// 个人信息
import React from 'react';
import dayjs from 'dayjs';
import {
  Radio, Form, Input, DatePicker,
  Selector,
} from '@roo/roo';

import {
  cardRule,
  emailRule,
  getRuleLen,
  phoneRule,
  requiredRule,
} from '@utils/rules';
import { getSafeDate } from '@utils/utils';
import { positionalTitleOptions } from '@utils/positionTitle';
import useInputTrim from '@hooks/useInputTrim';
import { getBirthByIdCard } from '../../_utils';

const { Field } = Form;
const RadioGroup = Radio.Group;

const Personal = (props) => {
  const {
    values, disabled, validateField, setFieldValue,
  } = props;

  const handlePositionBlur = useInputTrim(setFieldValue, 'position');

  return (
    <div className="form-patch">
      <Field
        hid={false}
        required
        rule={{ ...requiredRule, message: '请输入您的真实姓名' }}
        label="姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名"
        name="name"
        as={<Input maxLength={50} placeholder="请输入您的真实姓名" />}
      />
      <Field
        required
        rule={{
          validator: (rule, value, callback) => {
            if ([1, 2].includes(value)) {
              return callback();
            } else {
              return callback('请选择证件类型');
            }
          },
        }}
        label="身份信息"
        name="idCardType"
      >
        {({ value, handleChange }) => (
          <RadioGroup
            value={String(value)}
            disabled={disabled}
            onChange={(v) => {
              handleChange(Number(v), () => {
                if (values.birthday) validateField('birthday');
                if (values.idCardNo) validateField('idCardNo');
              });
            }}
          >
            <Radio value="1">身份证</Radio>
            <Radio value="2">护照</Radio>
          </RadioGroup>
        )}
      </Field>
      <Field
        value={values.idCardNo}
        hid
        rule={values.idCardType === 1 ? { ...cardRule } : { ...requiredRule }}
        label=""
        name="idCardNo"
      >
        {({ value, handleChange }) => (
          <Input
            maxLength={50}
            value={value}
            placeholder="请输入证件号码"
            onChange={(e) => {
              handleChange(e.target.value, () => {
                validateField('birthday');
              });
            }}
          />
        )}
      </Field>
      <Field
        required
        hid={false}
        rule={{
          validator: (rule, value, callback) => {
            if (!value) callback('请选择你的出生日期');
            const birthDayValue = dayjs(value);
            const idCardBirthDayValue = values.idCardType === 1 ? getBirthByIdCard(values.idCardNo) : undefined;
            if (birthDayValue.isBefore(dayjs('1981-01-01'))) {
              return callback('出生日期早于1981年1月1日，无法参与今年申报。');
            }
            if (idCardBirthDayValue && idCardBirthDayValue !== value) {
              return callback('此出生年月与身份证日期不一致，请检查后重新填写。');
            }
            return callback();
          },
        }}
        label="出生日期"
        name="birthday"
      >
        {({ value, handleChange }) => (
          <DatePicker
            value={getSafeDate(value)}
            format="YYYY-MM-DD"
            type="date"
            valueOfType="string"
            disabledDate={(cur) => cur.unix() < new Date('1980-12-31').getTime() / 1000 || cur.unix() > new Date('2026-12-31').getTime() / 1000}
            placeholder="青山科技奖奖励对象为45周岁及以下青年科技工作者"
            onChange={handleChange}
          />
        )}
      </Field>
      <Field name="gender" label="性别" required>
        {({ value, handleChange }) => (
          <RadioGroup
            value={String(value)}
            disabled={disabled}
            onChange={(v) => {
              handleChange(Number(v));
            }}
          >
            <Radio value="1">男</Radio>
            <Radio value="2">女</Radio>
          </RadioGroup>
        )}
      </Field>
      <Field
        required
        hid
        value={values.region}
        rule={getRuleLen(50, true)}
        label="国籍"
        name="region"
        as={<Input maxLength={50} placeholder="请输入您的国籍" />}
      />
      <div>
        <Field
          required
          hid
          value={values.phone}
          rule={phoneRule}
          label="手机号码"
          name="phone"
          as={<Input maxLength={50} placeholder="请输入您的的常用号码并保持畅通" />}
        />
        <Field
          hid
          required
          value={values.email}
          rule={emailRule}
          label="联系邮箱"
          name="email"
          as={<Input maxLength={50} placeholder="请输入您的联系邮箱，我们会给您发送重要通知" />}
        />
        <Field
          required
          hid
          value={values.companyName}
          rule={requiredRule}
          label="单位名称"
          name="companyName"
          as={<Input maxLength={100} placeholder="请输入您所在的单位名称" />}
        />
      </div>
      <Field
        required
        rule={getRuleLen(50, true)}
        label="职务"
        name="position"
        value={values.position}
        as={(
          <Input
            maxLength={50}
            placeholder="请输入职务"
            onBlur={handlePositionBlur}
          />
        )}
      />
      <Field
        required
        label="职称"
        name="positionalTitle"
        rule={requiredRule}
        value={values.positionalTitle}
        as={(
          <Selector
            options={positionalTitleOptions} clearable
            placeholder="请选择职称"
          />
        )}
      />
    </div>
  );
};

export default Personal;
